<template>
  <div class="steps">
    <h2 class="main-cl step-title">{{ $t('homeTemplate.steps.text_1') }}</h2>
    <p class="gray-cl step-des">{{ $t('homeTemplate.steps.text_2') }}</p>
    <div class="step-box">
      <div class="step-left">
        <div class="item-step" v-for="(item, index) in stepList" :key="index" @mouseenter="handlerItemStep(index)">
          <div class="white-cl item-step-num" :class="index === defaultIndex ? ' blue-bg' : 'gray-bg'">{{ index + 1 }}</div>
          <div class="item-step-line" :class="currentStep(index)" v-if="index < stepList.length - 1"></div>
          <div class="item-step-content">
            <div class="item-title" :class="index === defaultIndex ? ' blue-cl' : 'main-cl'">{{ item.title }}</div>
            <div class="gray-cl item-des">{{ item.des }}</div>
          </div>
        </div>
      </div>
      <div class="step-right">
        <template v-for="(item, index) in stepList">
          <div
            class="item-step-img"
            :key="index"
            :class="index === defaultIndex ? 'show' : 'hide'"
            :style="{ width: item.imgWidth, height: item.imgHeight }"
          >
            <img :src="item.img" />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import stepOne from '@/assets/img/step-one.png';
import stepTwo from '@/assets/img/step-two.png';
import stepThree from '@/assets/img/step-three.png';
import stepFour from '@/assets/img/step-four.png';

export default {
  data() {
    return {
      defaultIndex: 0,
      stepList: [
        {
          title: this.$t('homeTemplate.steps.text_3'),
          des: this.$t('homeTemplate.steps.text_4'),
          img: stepOne,
          imgWidth: '435px',
          imgHeight: '460px',
        },
        {
          title: this.$t('homeTemplate.steps.text_5'),
          des: this.$t('homeTemplate.steps.text_6'),
          img: stepTwo,
          imgWidth: '436px',
          imgHeight: '460px',
        },
        {
          title: this.$t('homeTemplate.steps.text_7'),
          des: this.$t('homeTemplate.steps.text_8'),
          img: stepThree,
          imgWidth: '384px',
          imgHeight: '460px',
        },
        {
          title: this.$t('homeTemplate.steps.text_1'),
          des: this.$t('homeTemplate.steps.text_9'),
          img: stepFour,
          imgWidth: '597px',
          imgHeight: '460px',
        },
      ],
    };
  },
  methods: {
    handlerItemStep(index) {
      this.defaultIndex = index;
    },
    currentStep(index) {
      return index <= this.defaultIndex ? 'blue-bg' : 'gray-bg';
    },
  },
};
</script>

<style lang="scss" scoped>
.steps {
  margin-top: 100px;
}
.step-title {
  font-size: 36px;
  line-height: 58px;
  margin-bottom: 8px;
  font-weight: 600;
}
.step-des {
  font-size: 16px;
  letter-spacing: 0.01em;
  margin-bottom: 48px;
}
.step-box {
  display: flex;
  // justify-content: space-between;
  .step-left {
    cursor: pointer;
    width: 600px;
    .item-step {
      padding-bottom: 60px;
      position: relative;
      .item-step-line {
        position: absolute;
        top: 40px;
        width: 1px;
        height: 100%;
        left: 20px;
      }
      .item-step-num {
        position: absolute;
        left: 0;
        top: 0;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        text-align: center;
        line-height: 40px;
        font-size: 20px;
        font-weight: 600;
      }
      .item-step-content {
        max-width: 340px;
        margin-left: 72px;
        .item-title {
          font-size: 24px;
          line-height: 38px;
        }
        .item-des {
          font-size: 16px;
          line-height: 26px;
        }
      }
    }
  }
  .item-step-img {
    position: absolute;
    top: 0;
    transition: all .5s ease-out;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .show {
    right: 0;
    left: 0;
  }
  .hide {
    left: 900px;
    right: -800px;
  }
  .step-right {
    position: relative;
    flex: 1;
    overflow: hidden;
  }
}
</style>
